import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.function.name.js";
import React, { createContext, useEffect, useContext, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { useConstant } from "../../hooks/useConstant";
import { useSegmentAnalytics } from '..';

/**
 * AnalyticsPageViewContext will be used to provide the generated page_view_id or any other stored values to
 * other components if they need it for Segment tracking events.
 */
export var AnalyticsPageViewContext = /*#__PURE__*/createContext(null);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var AnalyticsPageView = function AnalyticsPageView(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      contentId = _ref.contentId,
      contentSource = _ref.contentSource,
      children = _ref.children;

  // eslint-disable-next-line camelcase
  var _useSegmentAnalytics = useSegmentAnalytics(),
      analytics = _useSegmentAnalytics.analytics,
      deployable_name = _useSegmentAnalytics.deployable_name,
      deployable_version = _useSegmentAnalytics.deployable_version,
      deviceId = _useSegmentAnalytics.deviceId;

  var pageViewId = useConstant(function () {
    return uuid();
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      pageViewReady = _useState2[0],
      setPageViewReady = _useState2[1];

  useEffect(function () {
    if (!analytics || !deviceId) return;
    var payload = {
      deployable_name: deployable_name,
      deployable_version: deployable_version,
      pageview_id: pageViewId,
      traditional_device_id: deviceId,
      content_id: contentId,
      content_source: contentSource
    };

    if (typeof window !== 'undefined') {
      var _window$nerdwallet, _window$nerdwallet$ui;

      (_window$nerdwallet = window.nerdwallet) === null || _window$nerdwallet === void 0 ? void 0 : (_window$nerdwallet$ui = _window$nerdwallet.ui) === null || _window$nerdwallet$ui === void 0 ? void 0 : _window$nerdwallet$ui.setHeaderProps({
        segmentTrackingAttributes: {
          driverPageViewId: pageViewId
        }
      });
    }

    if (name) {
      analytics.page(name, payload);
    } else {
      analytics.page(payload);
    }

    setPageViewReady(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId]);
  return /*#__PURE__*/React.createElement(AnalyticsPageViewContext.Provider, {
    value: {
      pageName: name,
      pageViewId: pageViewId,
      pageViewReady: pageViewReady
    }
  }, children);
};
/**
 *
 * Hook to access all AnalyticsPageViewContext stored values
 * @returns context AnalyticsPageViewContext
 */

export var useAnalyticsPageView = function useAnalyticsPageView() {
  var context = useContext(AnalyticsPageViewContext);

  if (!context) {
    throw new Error('useAnalyticsPageView must be used within a <AnalyticsPageView />');
  }

  return context;
};